import { schema } from 'normalizr';

const telemetry = new schema.Entity('telemetry', {}, { idAttribute: 'id' });
const telemetrySchema = [telemetry];

export default telemetrySchema;



// WEBPACK FOOTER //
// ./src/normalizr-schemas/telemetrySchema.js